import { Gender } from "@/generated/client.generated";

export const stringToGender = (gender?: string) => {
  if (!gender) {
    return Gender.Unknown;
  }
  switch (gender.toLowerCase()) {
    case "mann": {
      return Gender.Male;
    }
    case "kvinne": {
      return Gender.Female;
    }
    case "ønsker ikke å oppgi": {
      return Gender.Other;
    }
    default: {
      return Gender.Unknown;
    }
  }
};

export const genderToString = (gender: Gender) => {
  switch (gender) {
    case Gender.Male: {
      return "mann";
    }
    case Gender.Female: {
      return "kvinne";
    }
    case Gender.Other: {
      return "ønsker ikke å oppgi";
    }
    default: {
      return "ukjent";
    }
  }
};
